import { Injectable, signal } from "@angular/core";
import { AppSettingsNavigationCategoryExtension } from "@geolib/geoappbase-client";

@Injectable({ providedIn: "root" })
export default class GeobusGeneralExtension extends AppSettingsNavigationCategoryExtension {

    public isEnabled(): boolean {
        return true;
    }

    public name = signal("general").asReadonly();

    public label = signal("SIDE_MENU.GENERAL.CATEGORY").asReadonly();

}
